module.exports = __webpack_public_path__ + "img/EP18Menu3_active.fa3c65b7.png";